<template>
	<iframe
		title="iframeComponent"
		:width="iframe_data.width"
		:height="iframe_data.height"
		:src="iframe_data.src"
		@load="load"
		v-show="iframe_data.loaded"
	></iframe>
</template>
<script>
export default {
	props: {
		iframe: {
			src: {
				type: String,
				default: "",
			},
			style: null,
			wrapperStyle: null,
			width: "100%",
			height: "500",
			loaded: false,
		},
	},
	data() {
		return {
			iframe_data: this.iframe,
		};
	},
	methods: {
		load() {
			this.iframe_data.loaded = true;
			this.$emit("iframeLoadedEmit");
		},
	},
};
</script>
